import ArrowForward from '@mui/icons-material/ArrowForward';
import { Box, Button, Stack, Typography } from '@mui/material';
import { OnlineTrainingCourseChapter } from '@onlineTraining/types';
import clsx from 'clsx';
import { FormattedMessage } from 'react-intl';
import { Link, useSearchParams } from 'react-router-dom';

export const ChapterRow = ({
    chapter,
    chapterNumber,
    isActive,
    onClick,
}: {
    chapter: OnlineTrainingCourseChapter;
    chapterNumber: number;
    isActive?: boolean;
    topBorder?: boolean;
    bottomBorder?: boolean;
    onClick: (chapterNumber: number, timecode: number) => void;
}) => {
    const [searchParams] = useSearchParams();
    const chapterSearchParams = new URLSearchParams(searchParams);
    chapterSearchParams.set('time', String(chapter.timecode));

    return (
        <Stack
            component={Link}
            to={{ pathname: '.', search: `?${chapterSearchParams.toString()}` }}
            direction="row"
            justifyContent="space-between"
            borderRadius="5px"
            paddingX={2.5}
            paddingY={2.5}
            flexShrink={0}
            width="100%"
            onClick={() => onClick(chapterNumber, chapter.timecode)}
            className={clsx('group hover:bg-[#F1F6FD] cursor-pointer', {
                'bg-secondaryNew-150': !isActive,
                'bg-[#F1F6FD]': isActive,
            })}
        >
            <Box>
                <Typography fontFamily="Inter" fontWeight={600} fontSize={14}>
                    <FormattedMessage
                        id="onlineTraining.courseDetail.chapter"
                        defaultMessage="Chapter {chapterNumber}"
                        values={{ chapterNumber }}
                    />
                </Typography>
                <Typography fontFamily="museo-sans" fontSize={14} fontWeight={500} className="line-clamp-2">
                    {chapter.title}
                </Typography>
            </Box>
            <Button variant="text" className="invisible group-hover:visible rounded-full min-w-0">
                {' '}
                <ArrowForward />
            </Button>
        </Stack>
    );
};
